export default __webpack_public_path__ + "static/media/workout-4.64bb7753.png";